import { t } from "@lingui/macro";
import { db, updateCall } from "@repo/ui";
import * as Sentry from "@sentry/react";
import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { isCallUnread } from "../utils/callReadStatus";

export function useMarkCallReadOnOpen(
	companyId: string | undefined,
	callId: string,
	status: string | null | undefined,
) {
	const opened = useRef<string | null>(null);
	useEffect(() => {
		if (!companyId || !callId) return;
		const key = `${companyId}/${callId}`;
		if (opened.current === key) return;
		opened.current = key;
		if (!isCallUnread(status)) return;
		void updateCall(db, companyId, callId, { interactionStatus: "read" }).catch(
			(error) => {
				Sentry.captureException(error);
				toast.error(
					t({
						id: "callMarkReadFailed",
						message: "The call could not be marked as read. Please try again.",
					}),
				);
			},
		);
	}, [companyId, callId, status]);
}
